<script>
import { mapState } from 'vuex';

import Course from '@/models/Course.js';
import { applyActivityPointsUpdates, normalizeCoursePointsBroadcast } from '@/utilities/coursePointsUpdated.js';

export default {
    name: 'CoursePointsUpdatedChecker',

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        echoReady() {
            return !!this.$store.state.Online.$echo;
        },
    },

    watch: {
        echoReady(ready) {
            if (ready) {
                this.$echo.channel('course-points-updated').listen('CoursePointsUpdated', async courseData => {
                    if (!Course.find(courseData.id)) {
                        // Assuming that the course is not in the store because the user doesn't have access to it.
                        return;
                    }

                    const { courseData: coursePatch, activities } = normalizeCoursePointsBroadcast(courseData);

                    await Course.update({
                        where: courseData.id,
                        data: coursePatch,
                    });

                    if (activities.length) {
                        applyActivityPointsUpdates(this.$store.state.Gradebook, {
                            courseId: courseData.id,
                            activities,
                        });
                    }
                });
            }
        },
    },

    render: () => null,
};
</script>
